<template>
  <div class="row">
    

    <div class=" col-md-12 modal-body-expense" style="padding: 15px;">
        <div class="row" style="padding: 5px;">
            <div class="col-md-12">
                <div class="alert alert-danger" v-if="errors.length">
                    <strong>Whoops!</strong> There were some problems with your
                    input.<br /><br />
                    <ul>
                        <li v-for="error in errors">{{ error }}</li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-8">
                        <div class="text-left section-title" style="padding: 5px;">
                            <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>
                               Collect Monthly Payment
                            </span>
                        </div>
                    </div>

                </div>
                <div class="row">
                    <div class="col-xs-6 col-sm-6 col-md-6">
                        <div class="form-group">
                            <label>Debtor:</label>
                            <select class="form-control"
                                    v-model="debtor_id"
                                    v-on:change="onChange">
                                <option v-for="debtor in debtors" :value="debtor.id">
                                    {{ debtor.floor }} - {{ debtor.number }} -
                                    {{ debtor.contact.name }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="col-xs-6 col-sm-6 col-md-6">
                        <div class="form-group">
                            <label>Amount:</label>
                            <input class="form-control"
                                   v-model="payment.amount"
                                   number
                                   data-type="currency" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6 col-sm-6 col-md-6">
                        <div class="form-group">
                            <label>Payment Type:</label>
                            <select class="form-control" v-model="payment.paymentType">
                                <option :value="1">
                                    Cash
                                </option>
                                <option :value="2">
                                    Cheque
                                </option>
                                <option :value="3">
                                    Bank Order
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="col-xs-6 col-sm-6 col-md-6">
                        <div class="form-group">
                            <label>Bank:</label>
                            <input class="form-control" v-model="payment.bank" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6 col-sm-6 col-md-6">
                        <div class="form-group">
                            <label>Reference:</label>
                            <input class="form-control" v-model="payment.reference" />
                        </div>
                    </div>

                    <div class="col-xs-6 col-sm-6 col-md-6">
                        <div class="form-group">
                            <label>Paid Date:</label>
                            <date-picker class="form-control"
                                         :format="customFormatter"
                                         v-model="payment.paidDate" />
                        </div>
                    </div>
                </div>
                <div class="col-md-12" style="padding-left: 0;">
                    <div class="col-md-12" style="padding-left: 0; padding-right: 0;">
                        <table class="table table-condensed">
                            <thead class="">
                                <tr>
                                    <th class="no-border text-center col-md-1">
                                        Month
                                    </th>
                                    <th class="no-border text-center col-md-3">
                                        Monthly Fee
                                    </th>
                                    <th class="no-border text-center col-md-3">
                                        Remaining
                                    </th>
                                    <th class="no-border text-center col-md-3">
                                        Payment
                                    </th>
                                    <th class="no-border col-md-2">
                                        <button @click="distribute()"
                                                onclick="return false;"
                                                class="btn btn-primary"
                                                :disabled="payment.amount <= 0">
                                            Distribute Amount
                                        </button>
                                    </th>
                                </tr>
                            </thead>
                            <tbody style="border: 1px solid rgba(221, 221, 221, 1);">
                                <tr v-for="(monthlyFee, key) in monthlyFees" :key="key">
                                    <td class="text-center">
                                        {{ monthlyFee.month }}
                                    </td>

                                    <td>
                                        <input class="form-control text-right"
                                               v-model="monthlyFee.monthlyFee"
                                               readOnly
                                               number
                                               data-type="currency" />
                                    </td>

                                    <td>
                                        <input class="form-control text-right"
                                               :value="$filters.toCurrency(monthlyFee.remainingMonthlyFee - (monthlyFee.amount == undefined ? 0 : monthlyFee.amount))"
                                               readOnly
                                               number
                                               data-type="currency" />
                                    </td>

                                    <td>
                                        <input :min="0"
                                               :max="monthlyFee.remainingMonthlyFee"
                                               :disabled="monthlyFee.paid == true"
                                               class="form-control text-right"
                                               v-model="monthlyFee.amount"
                                               number
                                               data-type="currency" />
                                    </td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 text-center">
                    <div class="text-center">
                        <button type="submit" @click="save()" class="btn btn-submit" style="margin: 15px;">
                            Submit
                        </button>
                        <button @click="closeModal()" class="btn btn-cancel">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";
export default {
  props: ["buildingId", "debtorId", "monthProp", "period"],
  data: function () {
    return {
      payment: {},
      monthlyFees: [],
      debtors: [],
      building: {},
      building_id: 0,
      month: 0,
      debtor_id: 0,
      date: "2016-10-16",
      errors: [],
      year: 0,
    };
  },

  watch: {
    value(val) {
      this.$emit("update:buildingId", val);
    },
    buildingId(val) {
        this.value = val;
        this.payment.amount = undefined;
      this.fetchProperty();
    },
  },

  mounted() {
    this.building_id = this.buildingId;
    if (this.buildingId) this.fetchProperty();
  },

  methods: {
    fetchProperty: async function () {
      var request = "/payments/monthly";
      // if(this.route=="home")
      //   request = '/home/statment/get/';
      request = request + "?id=" + this.buildingId;
      this.$http
        .get(request, {
          id: this.buildingId,
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.mute = false;
          // let myObjStr = JSON.stringify(data.expenseFees);
          this.debtors = data.properties;
            this.payment = data.payment;
            if(this.payment.amount == 0)
                this.payment.amount = undefined
        });
    },
    customFormatter(date) {
      //alert(moment(date).format('dd/MM/YYYY'));
      //return date | moment("dddd, MMMM Do YYYY")
      return format(date, "dd/MM/yyyy");
    },

    onChange: async function () {
      var request = "/payments/debtorbymonth";
      // if(this.route=="home")
      //   request = '/home/statment/get/';
      this.year = new Date().getFullYear() - (this.$period.yearsBack(this.period));
      request = request + "?id=" + this.debtor_id + "&year=" + this.year;
      this.$http
        .get(request, {
          id: this.debtor_id,
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.mute = false;
          // let myObjStr = JSON.stringify(data.expenseFees);
            this.monthlyFees = data.monthlyFees;
            for (var i = 0; i < this.monthlyFees.length; i++)
                this.monthlyFees[i].amount = undefined;
          console.log(this.monthlyFees);
        });
    },

    distribute: function () {
      try {
        var amount = parseFloat(this.payment.amount);

        for (var i = 0; i < this.monthlyFees.length; i++) {
          var remainingFee = parseFloat(
            this.monthlyFees[i].remainingMonthlyFee
          );
          if (amount > 0 && remainingFee > 0) {
            if (amount >= remainingFee) {
              this.monthlyFees[i].amount = remainingFee;
              amount = amount - remainingFee;
            } else {
              //alert(this.monthlyFees[i].remainingMonthlyFee);
              this.monthlyFees[i].amount = amount;
              amount = 0;
            }
          }
        }
      } catch (e) {
        console.log(e);
      }
    },

    closeModal: function () {
        this.$modal.hide("control-panel-add-form");
    },
    checkForm: function (e) {
      this.errors = [];

      if (!this.debtor_id) {
        this.errors.push("Please select debtor.");
      }

      if (this.payment.amount <= 0) {
        this.errors.push("Please enter payment amount.");
      }

      if (!this.payment.paymentType) {
        this.errors.push("Please enter payment type.");
      }

      if (!this.payment.paidDate) {
        this.errors.push("Please enter paid date.");
      }

      var paymentAmount = parseFloat(this.payment.amount);

      var allocatedAmount = 0;
      for (var i = 0; i < this.monthlyFees.length; i++) {
        allocatedAmount += parseFloat(this.monthlyFees[i].amount == undefined ? 0 : this.monthlyFees[i].amount);
      }

      if (paymentAmount != allocatedAmount)
        this.errors.push("Distributed amount does not match payment amount.");

      if (this.errors.length == 0) return;

      e.preventDefault();
    },
    save() {
      this.checkForm();
      this.$http
        .post("/payments/monthly", {
          propertyId: this.debtor_id,
          payment: this.payment,
          monthlyPaymentFees: this.monthlyFees,
        })
        .then(
          () => {
            this.closeModal();
            location.reload();
            this.$router.push({
              name: "controlpanel",
              params: { buildingId: this.buildingId },
            });
          },
          () => {
            alert("error");
            //  this.infoError = true
            //  this.loader = false
            //   this.password = ''
          }
        );
    },
  },

  computed: {},
};
</script>
